import { StyleSheet } from 'react-native';
import type { Theme } from '../../../src/theme/getTheme';

export function getSectionCardStyles(theme: Theme) {
  return StyleSheet.create({
    card: {
      backgroundColor: theme.background.card,
      borderRadius: theme.borderRadius.xl,
      paddingHorizontal: theme.spacing.lg,
      paddingVertical: theme.spacing.lg,
      marginBottom: theme.spacing.md,
      shadowColor: theme.shadow,
      shadowOffset: { width: 0, height: 2 },
      shadowOpacity: 0.06,
      shadowRadius: 8,
      elevation: 2,
    },
    titleRow: {
      flexDirection: 'row',
      alignItems: 'center',
      marginBottom: theme.spacing.md,
      gap: theme.spacing.sm,
    },
    /** Small-caps muted section label, matching the design's card headers. */
    title: {
      fontSize: 12,
      fontWeight: '700',
      letterSpacing: 0.8,
      textTransform: 'uppercase',
      color: theme.gray[500],
      flex: 1,
      minWidth: 0,
    },
  });
}
